import { cn } from '@/lib/cn';

export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <span role="status" aria-live="polite" className="inline-flex items-center gap-2">
      <span
        className={cn(
          'inline-block h-4 w-4 animate-spin rounded-full border-2 border-border border-t-tech',
          className,
        )}
      />
      {label ? <span className="text-sm text-muted">{label}</span> : null}
      <span className="sr-only">{label ?? 'Chargement…'}</span>
    </span>
  );
}

export function FullPageSpinner({ label = 'Chargement…' }: { label?: string }) {
  return (
    <div className="grid min-h-[60vh] place-items-center">
      <div className="flex flex-col items-center gap-3">
        <Spinner className="h-7 w-7" />
        <p className="text-sm text-muted">{label}</p>
      </div>
    </div>
  );
}

export function Skeleton({ className }: { className?: string }) {
  return <div className={cn('kha-skeleton', className)} aria-hidden="true" />;
}

export function SkeletonCard() {
  return (
    <div className="rounded-card border border-border bg-surface p-5">
      <Skeleton className="h-4 w-24" />
      <Skeleton className="mt-3 h-6 w-3/4" />
      <Skeleton className="mt-2 h-4 w-full" />
      <Skeleton className="mt-1.5 h-4 w-5/6" />
      <div className="mt-4 flex gap-2">
        <Skeleton className="h-6 w-16 rounded-full" />
        <Skeleton className="h-6 w-20 rounded-full" />
      </div>
    </div>
  );
}
